/**
 * View items stacked from top to bottom
 *
 */
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useSplitViewStyles = makeThemedStyles("StackView", (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
}));
const StackView = (
  props: React.PropsWithChildren<{
    gap?: string;
    padding?: string;
  }>
) => {
  const styles = useSplitViewStyles();
  const gap = props.gap || "10px";
  return (
    <div
      className={styles.root}
      style={{ gap: props.gap, padding: props.padding }}
    >
      {props.children}
    </div>
  );
};

export default StackView;
